import React, { useState } from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  required,
  useRedirect,
  useRefresh,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
  FormDataConsumer,
  Toolbar,
  BooleanInput,
  useDataProvider,
  CreateProps,
  SaveButton,
} from "react-admin";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import {
  AcademicYearResources,
  GetParam,
  StudentResources,
  sumCentsAmount,
  sumCentsAmountToDolar,
} from "utils/tools";
import {
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import AddressAutoCompleteInput from "components/AddressAutoCompleteInput";
import AcademicYearInput from "components/AcademicYearInput";
import CustomEndDateInput from "components/CustomEndDateInput";
import DaysOfWeekInput from "components/DaysOfWeekInput";
import moment from "moment";
import { useEffect } from "react";
import { GridinRow, GridLabel } from "utils/style";
import { find } from "lodash";
import StudentScheduleStartDateInput from "components/StudentScheduleStartDateInput";
import CalculationButton from "./components/CalculationButton";
import { calculationCostUpdateScheduleValidation } from "utils/validation";
import InvoiceInput from "./components/InvoiceInput";
import { useField } from "react-final-form";
import CommercialDocumentNoteInput from "./components/CommercialDocumentNoteInput";

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
    marginBottom: "15px",
  },
});

interface InitializeCommercialDocumentsProps {
  result: IResultCalculation;
  index: number;
}

const ScheduleCreate = (props: CreateProps) => {
  const [resultCalculations, setResultCalculations] = useState<
    IResultCalculation[]
  >([]);
  const [idAcademicYear, setIdAcademicYear] = useState<number>();
  const [holidays, setHolidays] = useState<IHoliday[]>([]);
  const [isNotTaking, setIsNotTaking] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [academicTerms, setAcademicTerms] = useState<IAcademicTerm[]>([]);
  const [studentSchedules, setStudentSchedules] = useState<IStudentSchedule[]>(
    []
  );
  const [areas, setAreas] = useState<IArea[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isCalculationButtonClicked, setIsCalculationButtonClicked] =
    useState(false);

  const [paymentPercentages, setPaymentPercentages] = useState<
    IPaymentPercentage[]
  >([]);

  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const classes = useStyles();
  const provider = useDataProvider();

  const format = "DD/MM/YY";

  const id = param.get("studentId");
  const studentResources = StudentResources(Number(id));

  useEffect(() => {
    provider
      .customGetListWithStaticParams(
        `students/${id}/paymentPercentages?Query.Filter=${JSON.stringify({})}`
      )
      .then(({ data }: { data: IPaymentPercentage[] }) => {
        setPaymentPercentages(data);
      });
  }, [id]);

  useEffect(() => {
    if (idAcademicYear) {
      // provider
      //   .getList("holidays", {
      //     filter: { AcademicYearId: Number(idAcademicYear) },
      //     pagination: {
      //       page: 1,
      //       perPage: 1000,
      //     },
      //     sort: {
      //       field: "Id",
      //       order: "ASC",
      //     },
      //   })
      //   .then(({ data }) => {
      //     setHolidays(data as IHoliday[]);
      //   });

      provider
        .getList("academicTerms", {
          filter: { AcademicYearId: Number(idAcademicYear) },
          pagination: {
            page: 1,
            perPage: 1000,
          },
          sort: {
            field: "Id",
            order: "ASC",
          },
        })
        .then(({ data }) => {
          setAcademicTerms(data as IAcademicTerm[]);
        });

      provider
        .getList("areas", {
          filter: { SchoolId: Number(studentResources.schoolId) },
          pagination: {
            page: 1,
            perPage: 1000,
          },
          sort: {
            field: "Id",
            order: "ASC",
          },
        })
        .then(({ data }) => {
          setAreas(data as IArea[]);
        });

      setLoading(true);
      provider
        .getList("studentSchedules", {
          filter: {
            StudentId: Number(id),
            AcademicYearId: Number(idAcademicYear),
          },
          pagination: {
            page: 1,
            perPage: 1000,
          },
          sort: {
            field: "StartedAt",
            order: "ASC",
          },
        })
        .then(({ data }) => {
          setStudentSchedules(data as IStudentSchedule[]);
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idAcademicYear]);

  let breadcrumbValue = [{ link: "", title: "", params: "" }];

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Schedules",
        link: `/students/${param.get("studentId")}/show/1`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Update",
        link: "",
        params: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: "",
      },
      {
        title: "Schedules",
        link: `/students/${param.get("studentId")}/show/1`,
        params: "",
      },
      {
        title: "Update",
        link: "",
        params: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  const CustomRedirect = ({ data }: any) => {
    redirect(`/students/${data.studentId}/show/1`);
    refresh();
  };

  const CustomToolbar = (props: any) => (
    <Toolbar {...props}>
      <SaveButton
        disabled={
          props.invalid
            ? props.invalid
            : !isLoaded && !isCalculationButtonClicked
        }
        resource="studentSchedules"
      />
    </Toolbar>
  );

  const transform = async (data: any) => {
    let isFromSchool: boolean;
    let isToSchool: boolean;

    // Set Value for Type Address is ToSchool or FromSchool or Both

    if (data.wayType) {
      if (data.wayType === "OneWayMorning") {
        isToSchool = true;
        isFromSchool = false;
      } else if (data.wayType === "OneWayAfternoon") {
        isFromSchool = true;
        isToSchool = false;
      } else {
        isToSchool = true;
        isFromSchool = true;
      }
    }

    data.isTaking = data.isNotTaking === true ? false : true;

    if (data.isNotTaking === false) {
      data.detail = {
        lat: data.locationData.LATITUDE,
        lng: data.locationData.LONGITUDE,
        street: data.street,
        blockNumber: data.blockNumber,
        unitNumber: data.unitNumber,
        postalCode: data.postalCode,
        building: data.building,
        address: data.address,
        isMonday: data.isMonday ? true : false,
        isTuesday: data.isTuesday ? true : false,
        isWednesday: data.isWednesday ? true : false,
        isThursday: data.isThursday ? true : false,
        isFriday: data.isFriday ? true : false,
        isFromSchool: isFromSchool,
        isToSchool: isToSchool,
        isMain: data.isMain ? true : false,
      };

      delete data.locationData;
      delete data.wayType;
      delete data.street;
      delete data.blockNumber;
      delete data.postalCode;
      delete data.building;
      delete data.address;
      delete data.isMonday;
      delete data.isTuesday;
      delete data.isWednesday;
      delete data.isThursday;
      delete data.isFriday;
      delete data.date;
      delete data.isMainAddress;
    } else {
      data.detail = null;
    }

    delete data.isNotTaking;

    return data;
  };

  const AcademicYearCallback = (value: any) => {
    setIdAcademicYear(value);
  };

  const academicYearResources = AcademicYearResources(idAcademicYear);

  // let excludeDates: IExcludeDates[] = [];
  // holidays.forEach((holiday: IHoliday) => {
  //   let temp: IExcludeDates = {
  //     startDate: holiday.date,
  //   };
  //
  //   excludeDates.push(temp);
  // });

  const InitializeCommercialDocuments = ({
    result,
    index,
  }: InitializeCommercialDocumentsProps) => {
    const taggedAccountingInvoiceId = useField(
      `commercialDocumentTags[${index}].taggedAccountingInvoiceId`
    );
    const commercialDocumentTagRateChartId = useField(
      `commercialDocumentTags[${index}].rateChartId`
    );

    const commercialDocumentNoteField = useField(
      `commercialDocumentNotes[${index}].note`
    );
    const commercialDocumentNoteRateChartField = useField(
      `commercialDocumentNotes[${index}].rateChartId`
    );

    useEffect(() => {
      if (isCalculationButtonClicked) {
        taggedAccountingInvoiceId.input.onChange(null);
        commercialDocumentTagRateChartId.input.onChange(result.rateChart.id);

        commercialDocumentNoteField.input.onChange(null);
        commercialDocumentNoteRateChartField.input.onChange(
            result.rateChart.id
        );
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCalculationButtonClicked]);

    return <></>;
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">Update Schedule</Typography>
      <Create
        transform={transform}
        onSuccess={CustomRedirect}
        title="Update Student Schedule"
        {...props}
      >
        <SimpleForm toolbar={<CustomToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>
            <Grid item xs={3}>
              <ReferenceInput
                label="Select Student"
                source="studentId"
                reference="students"
                disabled
              >
                <SelectInput
                  optionText={(choice: any) =>
                    `${choice.firstName} ${choice.lastName}`
                  }
                />
              </ReferenceInput>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">School Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="School"
                source="schoolId"
                reference="schools"
                validate={required()}
                filterToQuery={(searchText) => {
                  if (searchText !== "") return { search: searchText };
                }}
                disabled
              >
                <AutocompleteInput optionText="name" optionId="id" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <AcademicYearInput parentCallback={AcademicYearCallback} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Existing Schedules</Typography>
            </Grid>

            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Term</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>Schedule</TableCell>
                      <TableCell>Days of Week</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {studentSchedules.length > 0 ? (
                      <>
                        {studentSchedules.map(
                          (studentSchedule: IStudentSchedule, key: number) => {
                            return (
                              <TableRow key={`schedule-${key}`}>
                                <TableCell>
                                  {(() => {
                                    const term = find(academicTerms, [
                                      "id",
                                      studentSchedule.termId,
                                    ]);

                                    if (term === undefined) {
                                      return;
                                    }

                                    return term.name;
                                  })()}
                                </TableCell>
                                <TableCell>{`${moment
                                  .utc(studentSchedule.startDate)
                                  .format(format)} - ${moment
                                  .utc(studentSchedule.endDate)
                                  .format(format)}`}</TableCell>
                                <TableCell>
                                  <SanitizedGrid container spacing={2}>
                                    {studentSchedule.detail === null ? (
                                      <>
                                        <Grid item xs={12}>
                                          <Typography variant="body2">
                                            ---
                                          </Typography>
                                        </Grid>
                                      </>
                                    ) : (
                                      <>
                                        <Grid item xs={12} style={GridinRow}>
                                          <Typography
                                            variant="body2"
                                            style={GridLabel}
                                          >
                                            Block No. :{" "}
                                            {studentSchedule.detail.blockNumber}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={12} style={GridinRow}>
                                          <Typography
                                            variant="body2"
                                            style={GridLabel}
                                          >
                                            Street :{" "}
                                            {studentSchedule.detail.street}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={12} style={GridinRow}>
                                          <Typography
                                            variant="body2"
                                            style={GridLabel}
                                          >
                                            Postal Code :{" "}
                                            {studentSchedule.detail.postalCode}
                                          </Typography>
                                        </Grid>

                                        <Grid item xs={12} style={GridinRow}>
                                          <Typography
                                            variant="body2"
                                            style={GridLabel}
                                          >
                                            Area :{" "}
                                            {(() => {
                                              const area = find(areas, [
                                                "id",
                                                studentSchedule.areaId,
                                              ]);

                                              if (
                                                area === undefined ||
                                                area === null
                                              ) {
                                                return "-";
                                              }

                                              return area.name;
                                            })()}
                                          </Typography>
                                        </Grid>
                                      </>
                                    )}
                                  </SanitizedGrid>
                                </TableCell>
                                <TableCell>
                                  {(() => {
                                    if (studentSchedule.detail === null) {
                                      return "---";
                                    }

                                    if (studentSchedule.isTaking === false) {
                                      return "----";
                                    }

                                    if (
                                      studentSchedule.detail.isFromSchool &&
                                      studentSchedule.detail.isToSchool
                                    ) {
                                      return "Both";
                                    } else if (
                                      studentSchedule.detail.isToSchool
                                    ) {
                                      return "Bus To School";
                                    } else if (
                                      studentSchedule.detail.isFromSchool
                                    ) {
                                      return "Bus From School";
                                    }
                                  })()}
                                </TableCell>
                                <TableCell>
                                  {(() => {
                                    if (studentSchedule.detail === null) {
                                      return "---";
                                    }

                                    if (studentSchedule.isTaking === false) {
                                      return "----";
                                    }

                                    let days: string = "";

                                    if (studentSchedule.detail.isMonday) {
                                      days = days + " Monday,";
                                    }
                                    if (studentSchedule.detail.isTuesday) {
                                      days = days + " Tuesday,";
                                    }
                                    if (studentSchedule.detail.isWednesday) {
                                      days = days + " Wednesday,";
                                    }
                                    if (studentSchedule.detail.isThursday) {
                                      days = days + " Thursday,";
                                    }
                                    if (studentSchedule.detail.isFriday) {
                                      days = days + " Friday,";
                                    }

                                    return days.replace(/,(?=[^,]*$)/, "");
                                  })()}
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5}>
                          {loading ? "Loading..." : "No results found."}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Schedule</Typography>
            </Grid>

            <Grid item xs={4}>
              <StudentScheduleStartDateInput
                source="startedAt"
                label="Start Date *"
                parentStartDate={moment
                  .utc(academicYearResources?.startDate)
                  .format("yyyy-MM-DD")}
                parentEndDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                // excludeDates={excludeDates}
                // isWeekdays
              />
            </Grid>
            <Grid item xs={4}>
              <CustomEndDateInput
                source="endedAt"
                label="End Date *"
                parentEndDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                comparison="startedAt"
                // excludeDates={excludeDates}
                // isWeekdays
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <BooleanInput
                source="isNotTaking"
                label="Not Taking"
                defaultValue={false}
                onChange={(e: boolean) => {
                  setIsNotTaking(e);
                  setIsLoaded(false);
                }}
              />
            </Grid>

            {!isNotTaking && (
              <>
                <Grid item xs={12}>
                  <RadioButtonGroupInput
                    label="To and/or From"
                    source="wayType"
                    choices={[
                      {
                        id: "OneWayMorning",
                        name: "Morning (Bus to School)",
                      },
                      {
                        id: "OneWayAfternoon",
                        name: "Afternoon (Bus from School)",
                      },
                      { id: "TwoWay", name: "Both" },
                    ]}
                    validate={required()}
                  />
                </Grid>

                <DaysOfWeekInput />

                <Grid item xs={12}>
                  <Typography variant="h6">
                    Pick up & Drop off Address
                  </Typography>
                </Grid>

                <Grid item xs={4}>
                  <AddressAutoCompleteInput
                    label="Postal Code *"
                    source="postalCode"
                    referenceSource="locationData"
                  />
                </Grid>
                <Grid item xs={8}></Grid>

                <Grid item xs={2}>
                  <TextInput label="Unit No." source="unitNumber" />
                </Grid>
                <Grid item xs={2}>
                  <TextInput label="Block No." source="blockNumber" />
                </Grid>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                  <TextInput label="Building Name" source="building" />
                </Grid>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                  <TextInput
                    label="Street"
                    source="street"
                    validate={required()}
                  />
                </Grid>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                  <BooleanInput
                    label="Set this address as main address."
                    source="isMain"
                  />
                </Grid>
                <Grid item xs={8}></Grid>
              </>
            )}

            {isLoaded && (
              <Grid item xs={12}>
                {resultCalculations.length > 0 ? (
                  <div style={{ marginTop: -20 }}>
                    {resultCalculations.map(
                      (resulCalculation: IResultCalculation, index: number) => (
                        <div key={`result-${index}`}>
                          <InitializeCommercialDocuments
                            result={resulCalculation}
                            index={index}
                          />

                          <Grid item xs={12}>
                            <Typography variant="h6">
                              Cost Preview for Rate Chart #
                              {resulCalculation.rateChart.id} -{" "}
                              {resulCalculation.rateChart.name}
                            </Typography>

                            {resulCalculation.transactions.length > 0 ? (
                              <>
                                <TableContainer>
                                  <Table className={classes.table} size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Schedule Date</TableCell>
                                        <TableCell>Amount</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {resulCalculation.transactions.map(
                                        (
                                          item: IResultCalculationItem,
                                          key: number
                                        ) => {
                                          return (
                                            <TableRow
                                              key={`transaction-${key}`}
                                            >
                                              <TableCell>
                                                {moment
                                                  .utc(item.fromDate)
                                                  .format(format)}{" "}
                                                -{" "}
                                                {moment
                                                  .utc(item.toDate)
                                                  .format(format)}
                                              </TableCell>
                                              <TableCell>
                                                $ {item.total.toFixed(2) / 100}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        }
                                      )}

                                      <TableRow>
                                        <TableCell>Total :</TableCell>
                                        <TableCell>
                                          ${" "}
                                          {sumCentsAmountToDolar(
                                            resulCalculation.transactions
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>

                                <Grid item xs={4}>
                                  <Typography variant="h6" gutterBottom>
                                    Document Note
                                  </Typography>
                                  <CommercialDocumentNoteInput
                                    index={index}
                                    rateChartId={resulCalculation.rateChart.id}
                                  />
                                </Grid>
                              </>
                            ) : (
                              <Grid item xs={12}>
                                <Typography variant="h6">
                                  No Change in Cost.
                                </Typography>
                              </Grid>
                            )}
                          </Grid>

                          {sumCentsAmountToDolar(
                            resulCalculation.transactions
                          ) < 0 &&
                            paymentPercentages.length === 1 && (
                              <div style={{ marginTop: 15 }}>
                                <Grid item xs={12}>
                                  <Typography variant="h6" gutterBottom>
                                    Tag Invoice
                                  </Typography>
                                </Grid>

                                <Grid item xs={4}>
                                  <InvoiceInput
                                    label="Select Invoice"
                                    source={`commercialDocumentTags[${index}].taggedAccountingInvoiceId`}
                                    rateChartSource={`commercialDocumentTags[${index}].rateChartId`}
                                    rateChartId={resulCalculation.rateChart.id}
                                    creditNoteAmount={Math.abs(
                                      sumCentsAmount(
                                        resulCalculation.transactions
                                      )
                                    )}
                                  />
                                </Grid>
                              </div>
                            )}
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <Grid item xs={12}>
                    <Typography variant="h6">No Change in Cost.</Typography>
                  </Grid>
                )}
              </Grid>
            )}

            <Grid item xs={12}>
              <FormDataConsumer>
                {({ formData }) => {
                  return (
                    <div>
                      <CalculationButton
                        invalid={calculationCostUpdateScheduleValidation(
                          formData
                        )}
                        setResultCalculations={setResultCalculations}
                        setIsLoaded={setIsLoaded}
                        setIsCalculationButtonClicked={
                          setIsCalculationButtonClicked
                        }
                        formData={formData}
                      />
                    </div>
                  );
                }}
              </FormDataConsumer>
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default ScheduleCreate;
